import { render, staticRenderFns } from "./EditPopup.vue?vue&type=template&id=54148af1&scoped=true"
import script from "./EditPopup.vue?vue&type=script&lang=js"
export * from "./EditPopup.vue?vue&type=script&lang=js"
import style0 from "./EditPopup.vue?vue&type=style&index=0&id=54148af1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54148af1",
  null
  
)

export default component.exports